export default __webpack_public_path__ + "static/Education3-4f589320f842d6bca2a9753badd6577b.png";